export const SAVE_VIDEO = 'SAVE_VIDEO'
export const RESET_VIDEO = 'RESET_VIDEO'

export const saveVideo = (video) => ({ type: SAVE_VIDEO, video })
export const resetVideo = () => ({ type: RESET_VIDEO })